import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { bindActionCreators } from 'redux'

import { loadGroupMembers } from './actions'

export const mapStateToProps = (state) => ({
    groupStackState: state.getIn(['ui', 'groupStack']),
})
export const mapDispatchToProps = (dispatch) => bindActionCreators({ loadGroupMembers }, dispatch)

export default (GroupStackComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            groupStackState: IPropTypes.record.isRequired,
            loadGroupMembers: PropTypes.func.isRequired,
        }

        render() {
            return <GroupStackComponent {...this.props} />
        }
    }

    return HocConnect
}
